import { render, staticRenderFns } from "./mailInfoModal.vue?vue&type=template&id=7ac43ac3&scoped=true"
import script from "./mailInfoModal.vue?vue&type=script&lang=js"
export * from "./mailInfoModal.vue?vue&type=script&lang=js"
import style0 from "./mailInfoModal.vue?vue&type=style&index=0&id=7ac43ac3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac43ac3",
  null
  
)

export default component.exports